<!--<svelte:head>-->
<!--    <link href="https://cdn.jsdelivr.net/npm/daisyui@2.11.0/dist/full.css" rel="stylesheet" type="text/css" />-->
<!--    <script src="https://cdn.tailwindcss.com"></script>-->
<!--</svelte:head>-->
<script lang="ts">
    // https://svelte.dev/repl/4c5dfd34cc634774bd242725f0fc2dab?version=3.46.4
    import { clickOutside } from '../../utilities/clickOutside.js';
    import { _ } from 'svelte-i18n';

    import Select from '../../shared/Select.svelte';
    import IconMenu from '../../shared/Icons/IconMenu.svelte';
    import SelectTacticalPlan from '../../shared/SelectTacticalPlan.svelte';
    import { AssignmentManager } from '../Planning/PageScenario/AssignmentManager';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import ButtonSmallBlack from '../../shared/ButtonSmallBlack.svelte';
    import IconDropdown from '../../shared/Icons/IconDropdown.svelte';
    import type { ScenarioResponseType } from '../Planning/ScenarioTypes.js';
    import type { TacticalPlanResponseType } from '../TacticalPlan/TacticalPlanApi';

    export let scenarioManager: AssignmentManager;
    export let text: string = '';
    export let openText: string = $_('Change tactical plan if you wish');
    export let buttonText: string|null = null;
    export let disabled: boolean = false;
    export let onChange: (tacticalPlanId: number, resetWithManualChange: boolean, ignoreDefinedOrder: boolean) => void;
    export let onClose: () => void = () => {};
    // export let onCreateScenario: ((tacticalPlanId: number) => void)|null = null;
    // export let onChangeScenario: ((scenarioId: number) => void)|null = null;
    export let enableResetWithManualChanges: boolean = false;
    export let enableIgnoringDefinedOrder: boolean = false;
    export let tacticalPlans: TacticalPlanResponseType[] = [];

    let isDropdownOpen: boolean = false; // default state (dropdown close)
    let resetWithManualChanges: boolean = false;
    let hasCurrentScenarioOrderedAssignment = false;
    export let selectedTacticalPlan: number | null = null;
    let allScenariosToCompare: ScenarioResponseType[] | null = [];

    export const handleDropdownClick = () => {
        if (isDropdownOpen === false && enableIgnoringDefinedOrder) {
            hasCurrentScenarioOrderedAssignment = false;
            scenarioManager.getScenarioSections(false).forEach((a) => {
                if (a.getRouteInfo()?.options?.ordered === true) hasCurrentScenarioOrderedAssignment = true;
            });
        }
        isDropdownOpen = !isDropdownOpen; // togle state on click
    };

    const handleDropdownFocusLoss = ({ relatedTarget, currentTarget }) => {
        console.log('handleDropdownFocusLoss,', relatedTarget, currentTarget);
        // use "focusout" event to ensure that we can close the dropdown when clicking outside or when we leave the dropdown with the "Tab" button
        if (relatedTarget instanceof HTMLElement && currentTarget.contains(relatedTarget)) return; // check if the new focus target doesn't present in the dropdown tree (exclude ul\li padding area because relatedTarget, in this case, will be null)
        isDropdownOpen = false;
        onClose();
    };

    const handleClickOutside = () => {
        isDropdownOpen = false;
        onClose();
    };

    // $: selectedTacticalPlan = scenarioManager.getTacticalPlanId();

    $: allScenariosToCompare = scenarioManager.getAllScenariosToCompare();
</script>

<div class="menu-dropdown-container">
    <div
        class="dropdown"
        class:clickable={!disabled}
        use:clickOutside
        on:click_outside={handleClickOutside}
    >
        {#if disabled}
            <div class="dropdown-text">{text}</div>
        {:else}
            <!-- svelte-ignore a11y-mouse-events-have-key-events -->
            <div on:click={handleDropdownClick} class="dropdown-text">{text}</div>
            <IconDropdown on:click={handleDropdownClick} scale={0.7} />
            {#if isDropdownOpen}
                <div
                    class="menu-list"
                    style:visibility={isDropdownOpen ? 'visible' : 'hidden'}
                    autofocus
                >
                    {#if enableIgnoringDefinedOrder && hasCurrentScenarioOrderedAssignment}
                    <div>
                        <ButtonSmallBlack
                            text={$_('Compare_with_optimized_routes')}
                            on:click={() => {
                                isDropdownOpen = false;
                                onChange(scenarioManager.getTacticalPlanId(), false, true);
                            }}
                        />
                    </div>
                    <div class="separator"><span>{$_('or')}</span></div>
                {/if}
                    <div>{openText}</div>
                    <SelectTacticalPlan
                        {tacticalPlans}
                        {selectedTacticalPlan}
                        day={scenarioManager.getDay()}
                        onChange={tpid => {
                            selectedTacticalPlan = tpid;
                        }}
                    />
                    {#if enableResetWithManualChanges}
                        <Checkbox
                            label={$_('Recalculate')}
                            checked={resetWithManualChanges}
                            onChange={() => {
                                resetWithManualChanges = !resetWithManualChanges;
                            }}
                        />
                    {/if}
                    <ButtonSmallBlack
                        text={buttonText ? buttonText : (enableResetWithManualChanges ? $_('Change') : $_('Recalculate'))}
                        disabled={selectedTacticalPlan === null}
                        on:click={() => {
                            if (selectedTacticalPlan) {
                                isDropdownOpen = false;
                                onChange(selectedTacticalPlan, resetWithManualChanges, true);
                            }
                        }}
                    />
                    <!--{#if typeof(onCreateScenario) == 'function' && false}-->
                    <!--    <ButtonSmallBlack-->
                    <!--        text={$_('Create scenario')}-->
                    <!--        disabled={selectedTacticalPlan === null}-->
                    <!--        on:click={() => {-->
                    <!--            if (selectedTacticalPlan) {-->
                    <!--                isDropdownOpen = false;-->
                    <!--                onCreateScenario(selectedTacticalPlan);-->
                    <!--            }-->
                    <!--        }}-->
                    <!--    />-->
                    <!--    {#if allScenariosToCompare && allScenariosToCompare.length > 1}-->
                    <!--        <div class="scenario-selector">-->
                    <!--            <div>{$_('Change scenario')}</div>-->
                    <!--            <Select-->
                    <!--                items={allScenariosToCompare.map((s) => { return {id: s.id.toString(), label: s.name}; })}-->
                    <!--                selected={scenarioManager.getScenarioId()?.toString()}-->
                    <!--                useDefaultStyles={true}-->
                    <!--                onChange={s => {-->
                    <!--                    if (parseInt(s) !== scenarioManager.getScenarioId() && typeof(onChangeScenario) == 'function') {-->
                    <!--                        onChangeScenario(parseInt(s));-->
                    <!--                    }-->
                    <!--                    return true;-->
                    <!--                }}-->
                    <!--            />-->
                    <!--        </div>-->
                    <!--    {/if}-->
                    <!--{/if}-->
                </div>
            {/if}
        {/if}
    </div>
</div>

<style>
    :root {
        --menu-background: #6c6b6a;
        --menu-color: #ffffff;
    }
    .menu-dropdown-container {
        z-index: 200;
        /*z-index: 1000;*/
    }
    .dropdown-text {
        font-size: 14px;
    }
    .menu-list {
        padding: 16px;
        background-color: var(--selected-item-background);
        border: 1px solid #ccc;
        color: black;
        border-radius: 6px;
        font-size: 13px;
        position: absolute;
        /*right:0;*/
        left: 0;
        top: 39px;
        box-shadow: -1px 11px 31px -10px rgba(0, 0, 0, 0.75);
        min-width: 230px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        row-gap: 12px;
        z-index: 100;
    }
    .dropdown {
        /*display: inline-block;*/
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-weight: 500;
    }
    .clickable {
        cursor: pointer;
    }
    .scenario-selector {
        margin-top: 10px;
        border-top: 1px solid #999999;
        padding-top: 10px;
        display: flex;
        flex-direction: column;
        row-gap: 12px;
    }
    .separator {
        height: 0px;
        border-bottom: 1px solid #999999;
        margin: 10px 0 5px 0;
        text-align: center;
    }
    .separator span {
        display: inline-block;
        position: relative;
        top: -7px;
        padding: 0 8px;
        background-color: #f0f0f0;
        font-weight: normal;
    }
</style>
